import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("h2", null, "Cookie Policy", -1)
const _hoisted_2 = /*#__PURE__*/_createElementVNode("h5", null, " Please check your cookie settings below and turn on any cookies that you are happy with. Cookies can be turned on or off, and your preferences are automatically saved. ", -1)
const _hoisted_3 = { class: "my-10 md:my-12" }
const _hoisted_4 = { class: "flex justify-end mt-6 sm:mb-6" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Editorial = _resolveComponent("Editorial")!
  const _component_Toggle = _resolveComponent("Toggle")!
  const _component_ContentBlockDivider = _resolveComponent("ContentBlockDivider")!
  const _component_AppButton = _resolveComponent("AppButton")!
  const _component_ContentBlock = _resolveComponent("ContentBlock")!
  const _component_AppContent = _resolveComponent("AppContent")!

  return (_openBlock(), _createBlock(_component_AppContent, null, {
    default: _withCtx(() => [
      _createVNode(_component_ContentBlock, null, {
        default: _withCtx(() => [
          _createVNode(_component_Editorial, null, {
            default: _withCtx(() => [
              _hoisted_1,
              _hoisted_2
            ]),
            _: 1
          }),
          _createElementVNode("div", _hoisted_3, [
            _createVNode(_component_Toggle, {
              modelValue: _ctx.preferencesCookies,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.preferencesCookies) = $event)),
              label: "Preferences",
              "help-text": "These cookies allow the website to remember your preferences, to allow you to personalise features.",
              "unselected-label": "Off",
              "selected-label": "On",
              class: "hidden md:block"
            }, null, 8, ["modelValue"]),
            _createVNode(_component_Toggle, {
              modelValue: _ctx.preferencesCookies,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.preferencesCookies) = $event)),
              label: "Preferences",
              "help-text": "These cookies allow the website to remember your preferences, to allow you to personalise features.",
              class: "md:hidden"
            }, null, 8, ["modelValue"]),
            _createVNode(_component_ContentBlockDivider),
            _createVNode(_component_Toggle, {
              modelValue: _ctx.statisticsCookies,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.statisticsCookies) = $event)),
              label: "Statistics",
              "help-text": "These are cookies allow us to measure the success of the website in order to improve it in future.",
              "unselected-label": "Off",
              "selected-label": "On",
              class: "hidden md:block"
            }, null, 8, ["modelValue"]),
            _createVNode(_component_Toggle, {
              modelValue: _ctx.statisticsCookies,
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.statisticsCookies) = $event)),
              label: "Statistics",
              "help-text": "These are cookies allow us to measure the success of the website in order to improve it in future.",
              class: "md:hidden"
            }, null, 8, ["modelValue"]),
            _createVNode(_component_ContentBlockDivider),
            _createVNode(_component_Toggle, {
              modelValue: _ctx.marketingCookies,
              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.marketingCookies) = $event)),
              label: "Marketing",
              "help-text": "These are cookies that may allow us to add commercial content to the website in future.",
              "unselected-label": "Off",
              "selected-label": "On",
              class: "hidden md:block"
            }, null, 8, ["modelValue"]),
            _createVNode(_component_Toggle, {
              modelValue: _ctx.marketingCookies,
              "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.marketingCookies) = $event)),
              label: "Marketing",
              "help-text": "These are cookies that may allow us to add commercial content to the website in future.",
              class: "md:hidden"
            }, null, 8, ["modelValue"])
          ]),
          _createVNode(_component_Editorial, null, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_4, [
                _createVNode(_component_AppButton, {
                  type: "primary",
                  onClick: _ctx.handleContinue
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(" Continue ")
                  ]),
                  _: 1
                }, 8, ["onClick"])
              ])
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}